/**
 * Shared contract for Admin + Box Office order search.
 *
 * The Strapi `order.unifiedSearch` controller is the only search implementation.
 * Both apps must send this payload shape so results stay identical.
 */
export const UNIFIED_ORDER_SEARCH_PATH = '/orders/unified-search';
export const SEAT_LOOKUP_EVENTS_PACKAGES_PATH = '/orders/seat-lookup-find-events-packages';
export const UNIFIED_ORDER_SEARCH_DEFAULT_PER_PAGE = 20;
export const UNIFIED_ORDER_SEARCH_PER_PAGE_OPTIONS = [
    { label: '20', value: 20 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
];
/**
 * Fields matched by a general `searchTerm` in `order.unifiedSearch`.
 * Matching is case-insensitive contains (`$containsi`).
 * Multi-word terms require every token to match at least one of these fields.
 */
export const UNIFIED_ORDER_SEARCH_GENERAL_FIELDS = [
    'firstName',
    'lastName',
    'email',
    'orderId',
    'users_permissions_user.firstName',
    'users_permissions_user.lastName',
    'users_permissions_user.email',
];
export const UNIFIED_ORDER_SEARCH_SEAT_FIELDS = [
    'sectionNumber',
    'rowNumber',
    'seatNumbers',
];
export const UNIFIED_ORDER_SEARCH_BY = {
    ALL: 'all',
    EVENT: 'event',
    PACKAGE: 'package',
    FLEX_PACK: 'flex-pack',
};
const DEFAULT_SOURCE_FILTERS = [
    { label: 'Website', value: 'website', selected: true },
    { label: 'Ticket assignment', value: 'ticket_assignment', selected: true },
    { label: 'Ticket exchange', value: 'ticket_exchange', selected: true },
    { label: 'Box office', value: 'box_office', selected: true },
    { label: 'Transfer', value: 'transfer', selected: true },
];
export function getDefaultUnifiedOrderSearchSourceFilters() {
    return DEFAULT_SOURCE_FILTERS.map((filter) => ({ ...filter }));
}
export function resolveUnifiedSearchBy(selectedEventOrPackage) {
    if (!selectedEventOrPackage)
        return UNIFIED_ORDER_SEARCH_BY.ALL;
    if (selectedEventOrPackage.event)
        return UNIFIED_ORDER_SEARCH_BY.EVENT;
    if (selectedEventOrPackage.package)
        return UNIFIED_ORDER_SEARCH_BY.PACKAGE;
    return UNIFIED_ORDER_SEARCH_BY.FLEX_PACK;
}
export function validateSeatSearch({ section, row, seat, }) {
    if (row && !section) {
        return {
            valid: false,
            message: 'Please enter Section before searching by Row',
        };
    }
    if (seat && !row) {
        return {
            valid: false,
            message: 'Please enter Section and Row before searching by Seat',
        };
    }
    return { valid: true };
}
export function buildUnifiedSearchPayload({ organizationUUID, selectedEventOrPackage, searchTerm, sectionNumber, rowNumber, seatNumbers, sourceFilters, page = 1, perPage = UNIFIED_ORDER_SEARCH_DEFAULT_PER_PAGE, } = {}) {
    const seatSearch = Boolean(sectionNumber || rowNumber || seatNumbers);
    return {
        organizationUUID,
        uuid: selectedEventOrPackage?.uuid,
        by: resolveUnifiedSearchBy(selectedEventOrPackage),
        searchTerm: seatSearch ? undefined : searchTerm,
        sectionNumber,
        rowNumber,
        seatNumbers,
        sourceFilters,
        page,
        perPage,
    };
}
